<template>
  <div class="block space-y-1" @click="showProjectTaskModal">
    <div v-html="message" class="text-gray-800" />
    <span class="text-xs inline-block text-gray-600">
      {{ createdAt }}
    </span>
  </div>
</template>

<script>
import moment from 'moment';
import { marked } from 'marked';

export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  computed: {
    message() {
      return marked(this.notification?.data?.message || '');
    },
    createdAt() {
      return moment(this.notification.createdAt).fromNow();
    },
  },
  methods: {
    showProjectTaskModal() {
      this.$modal.show({
        component: 'ProjectTaskModal',
        props: {
          taskId: this.notification.data.project_task_id,
        },
        on: {},
        hideEvent: 'task-modal:closed',
      });
    },
  },
};
</script>
